import { render, staticRenderFns } from "./NapTien.vue?vue&type=template&id=8acb7f10&"
import script from "./NapTien.vue?vue&type=script&lang=js&"
export * from "./NapTien.vue?vue&type=script&lang=js&"
import style0 from "./NapTien.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports